import index from "./compose.vue";
export default index;
